import { useMutation } from "react-query";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteUnit = ({ unitId }: { unitId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/Units/DeleteUnit/${unitId}`);
};

type QueryFnType = typeof deleteUnit;

type UseDeleteUnitOptions = {
  unitId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteUnit = ({ config }: UseDeleteUnitOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στην διαγραφή της Μονάδας.`, 500);
      console.error("Couldnt delete Unit", error);
      setIsNotificationVisible(true);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllUnits"]);
      addNotification(`Η Μονάδα Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteUnit,
  });
};
